<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <h3>{{ pageTitle }}</h3>
      <hr>
      
      <AppForm
        v-show="pageShowData"
        ref="pageForm" 
        v-bind:formParameter="PARAM"
        v-bind:permission="permission"
        v-on:form-input="onFormInput"
        v-on:form-change="onFormChange" >

        <div
          slot="jt-form-slot-_terminationDate">
          <br>
          <TemplateFeedback ref="reactivationDateFeedback" />
        </div>

        <div
          slot="jt-form-slot-sectionProductSubscriptionLease">
          <PagePLReactivationFormLease
            ref="pageTableLease" />
        </div>
        
      </AppForm>

      <TemplateFeedback ref="pageFeedback" />

      <button v-show="pageShowData" v-on:click="onCancelButtonClick" type="button" class="btn btn-default">
        Cancel
      </button>

      <TemplateButton v-show="hasAddOrEditPermission() && pageShowSumbit && pageCanSubmit" v-on:click="onSaveButtonClick" type="button" class="btn btn-success">
        Submit Application
      </TemplateButton>

      <TemplateButton v-show="approvalShowApprove" v-on:click="onApproveButtonClick" type="button" class="btn btn-danger">
        Approve
      </TemplateButton>

      <TemplateButton v-show="approvalShowPendingReturn" v-on:click="onPendingReturnButtonClick" type="button" class="btn btn-danger">
        Pending Passcard Return
      </TemplateButton>

      <TemplateButton v-show="approvalShowComplete" v-on:click="onCompleteButtonClick" type="button" class="btn btn-danger">
        Complete
      </TemplateButton>

      <TemplateButton v-show="approvalShowComplete" v-on:click="onExpiredButtonClick" type="button" class="btn btn-danger">
        Expired
      </TemplateButton>

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppForm from "@/components/App/AppForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"
import PagePLReactivationFormLease from "@/components/Page/ParkingLicense/PagePLReactivationFormLease";

var querystring = require('querystring');
var moment = require('moment');

let commencementDateValidate = function(date) {
  return true;
}

const PARAM = [
  {
    key: 'applicationCarpark',
    text: 'Car Park',
    form_select: {
      data: [],
      formatSelectOptionValue: (data) => data.id, 
      formatSelectOptionText: (data) => data.carparkCode ? `${data.carparkCode} - ${data.name}` : data.name,
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'licenseID',
    text: 'Parking License',
    form_select: {
      data: [],
      formatSelectOptionText: option => {
        let text = helper.plFormPLNum(option.licenseOperatorNum, option.carparkID);
        let customer = option['_customer'];
        text += customer ? ` - ${customer.name} (${customer.nationalID})` : '';
        return text;
      },
    },
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'sectionProductSubscription',
    form_section: 'Product Subscription',
  },
  {
    key: '_lease',
    form_label_attr: { style: 'display:none'},
    form_select: {
      data: [],
      formatSelectOptionText: option => {
        if(typeof option === 'string') {
          return option;
        }
        let text = `${option['leaseZone']} - ${option['leaseProductName']} `;
        text += option['leasePasscard'] ? '(' + option['leasePasscard'] + ')' : '';
        return text;
      },
    },
    form_edit_hide: true,
    form_input_attr: { 'multiple' : true },
    form_chosen_multiple: true,
  },
  {
    key: 'sectionProductSubscriptionLease',
    form_html: () => '',
  },
  {
    key: '_terminationDate',
    text: 'Reactivation Effective Date',
    form_datepicker: {
      beforeShowDay: function(date) {
        return commencementDateValidate(date);
      },
    },
  },
  {
    key: 'reactivationContactNo',
    text: 'Contact No.',
    form_default: 0,
    form_phone: true,
  },
  {
    key: 'reactivationRefundMethod',
    text: 'Refund Method',
    form_default: 0,
    form_select: [
      {0:'GIRO'}, 
      {1:'Cheque'},
    ]
  },
  {
    key: 'reactivationGiroSection',
    form_section: 'GIRO Information',
  },
  {
    key: 'reactivationGiroAccountHolder',
    text: 'Bank Account Holder Name',
    form_input_validation: [],
  },
  {
    key: 'reactivationGiroEmail',
    text: 'Email',
    form_input_validation: [],
  },
  {
    key: 'reactivationGiroBankName',
    text: 'Bank Name',
    form_input_validation: [],
  },
  {
    key: 'reactivationGiroVerification',
    form_section: 'GIRO Verification Method',
  },
  {
    key: 'reactivationGiroRemark',
    form_html: () => 'Please fill in at least one of the GIRO Verification Method at below.',
  },
  {
    key: 'reactivationGiroNewIC',
    text: 'New I/C No.',
    form_input_validation: [],
  },
  {
    key: 'reactivationGiroOldIC',
    text: 'Old I/C No.',
    form_input_validation: [],
  },
  {
    key: 'reactivationGiroBusinessRegNo',
    text: 'Business Registration No.',
    form_input_validation: [],
  },
  {
    key: 'reactivationChequeSection',
    form_section: 'Posting Address Information',
  },
  {
    key: 'reactivationChequePayableTo',
    text: 'Cheque Payable To',
    form_input_validation: [],
  },
  {
    key: 'reactivationChequeAddress1',
    text: 'Address 1',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_validation: [],
  },
  {
    key: 'reactivationChequeAddress2',
    text: 'Address 2',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_validation: [],
  },
  {
    key: 'reactivationChequeAddress3',
    text: 'Address 3',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_validation: [],
  },
  {
    key: 'reactivationChequePostalCode',
    text: 'Postal Code',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_validation: [],
  },
  {
    key: 'reactivationChequeCity',
    text: 'City',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_validation: [],
  },
  {
    key: 'reactivationChequeState',
    text: 'State',
    form_container_attr: {
      'class': 'col-lg-6',
    },
    form_input_validation: [],
  },
  {
    form_section: 'Reactivation Terms and Conditions',
  },
  {
    form_html: () => `NOTES: It is important to read all the Term and Conditions delivered with this form.<br>
<br>
1.0 Written or online reactivation notice of one (1) calendar month shall be given before the reactivation date.<br>
2.0 Conditions precedent to the refund of deposit, failing which service provider shall entitle to retain the deposit: -<br>
<ul>
<li>(a) the access card/tag being returned to service provider in good working order and condition within 14 days from the reactivation date</li>
<li>(b) all outstanding payment due to service provider having being fully paid up to the reactivation date</li>
</ul>
3.0 Parking License must be maintained for a minimum continuous period of ONE (1) calendar month prior to reactivation as stipulated in our Terms and Conditions of Parking License Agreement.<br>
4.0 All terms and conditions as stated in Parking License Application Form shall apply and having being fully complied with.<br>
5.0 Please proceed to the Car Park Site Office to fill up Lost/Faulty/Damage/Return Passcard Form and surrender the parking access card/tag within 14 days from the reactivation date (last day).<br>
6.0 Any Refund, if applicable, shall be credited directly into the customer's bank account or at the customer's request where the refund is made via cheque.`,
  },
  {
    key: 'applicationTnC',
    text: 'I agree and accept the Reactivation Terms and Conditions *',
    form_checkbox: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'applicationStaff',
    text: 'Staff Name',
    form_select: [],
    form_chosen: true,
    form_edit_input_attr: {
      disabled: true,
    },
  },
  {
    key: 'applicationStaffNo',
    text: 'Staff No',
    form_input_attr: {
      disabled: true,
    },
  },
];

const PARAM_MAP = helper.transformParamToMap(PARAM);

export default {
  name: "PagePLReactivationForm",
  components: {
    TemplateBasic,
    TemplateButton,
    TemplateFeedback,
    AppForm,
    PagePLReactivationFormLease,
  },
  data () {
    return {
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Parking License', url: '/parkinglicense' },
        { name: 'Reactivation Application', url: '/plReactivation' },
      ],

      API_PATH: "/api2/application/",
      PARAM,
      PARAM_MAP,

      pageTitle: null,
      pageShowData: false,
      pageShowSumbit: false,
      pageCanSubmit: false,

      pageStaff: null,
      pageCarpark: null,
      pageZone: null,
      pageCustomer: null,
      pagePasscard: null,

      pageLicense: null,
      pageSeason: undefined,
      pageFees: {},
      pageParker: undefined,

      approvalShowApprove: false,
      approvalShowPendingReturn: false,
      approvalShowComplete: false,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
    
    this.$nextTick(() => {
      helper.setSidebar('/plReactivation');
    });

    this.hideFormFromKey('licenseID');
    this.loadStaff();

    try {
      let self = this;
      commencementDateValidate = function(date) {
        if(date <= new Date()) {
          return false;
        }
        return true;
      }
      $('#jt-form-input-_terminationDate').datepicker('update');
    } catch (e) {
    }

    // TODO kw1 reactivation date cannot be earlier than commencement date
  },
  methods: {
    hideFormFromKey(key) {
      if(key === null) {
        this.pageShowSumbit = true;
      }

      let hide = false;
      let refundMethod = this.$refs['pageForm'].formData['reactivationRefundMethod'];
      this.PARAM.forEach(parameter => {
        if(parameter.key === key) {
          hide = true;
        }

        if(hide) {
          parameter.form_hide = hide;
          return;
        }

        if(parameter.key && parameter.key.startsWith('reactivationGiro')) {
          parameter.form_hide = !helper.compareID(refundMethod, 0);
          return;
        }

        if(parameter.key && parameter.key.startsWith('reactivationCheque')) {
          parameter.form_hide = !helper.compareID(refundMethod, 1);
          return;
        }

        parameter.form_hide = hide;
      });
    },

    // 1. load staff, customer & carpark
    // 2a. if add - init application, load license, license lease
    // 2b. if edit - load application, license (specific, for customer + carpark), application data, application lease
    // 3. load leases related (parker, season, season fees)
    loadStaff() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading staff data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/personnel/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          helper.inputSelectSetOption(this.PARAM_MAP['applicationStaff'], response.data);
          this.loadCustomer();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'staff data'));
        });
    },
    loadCustomer() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading profile data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageCustomer = response.data;
          this.loadCarpark();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'profile data'));
        });
    },
    loadCarpark() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          // helper.inputSelectSetOption(this.PARAM_MAP['applicationCarpark'], this.pageCarpark = response.data);
          // this.loadZone();

          this.pageCarpark = response.data
          this.setCarparInput();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park data'));
        });
    },
    setCarparInput() {
      let feedbackItem = 'car park license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          let allParkingLicense = response.data;
          this.pageCarpark = this.pageCarpark.filter(k => {
            return allParkingLicense.find(j => j.carparkID === k.id)
          });

          helper.inputSelectSetOption(this.PARAM_MAP['carparkID'], this.pageCarpark);
          this.loadZone();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        });
    },
    loadZone() {
      this.$refs['pageFeedback'].setFeedbackLoading('Loading car park zone data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/zone',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pageZone = response.data;
          this.loadApplication();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', 'car park zone data'));
        });
    },

    loadApplication() {
      let reactivationID = this.$route.query.reactivationID;
      if(reactivationID) {
        let feedbackItem = 'parking license reactivation application info';
        this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
        this.$http
          .get(
            helper.API_URL + '/api2/licenseTerminate/' + reactivationID,
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
            this.pageTitle = 'Reactivation Application';
            this.pageShowData = true;

            let temp = response.data[0];
            temp['_terminationDate'] = helper.formatDate(temp['reactivationDate']);
            this.$refs['pageForm'].setForm(false, temp);

            if(temp['status'] === 'Pending Approval' || temp['status'] === 'Pending') {
              this.approvalShowApprove = true;
              this.pageCanSubmit = true;
            } else if(temp['status'] === 'Approve') {
              this.approvalShowPendingReactivation = true;
              this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
            } else if(temp['status'] === 'Pending Reactivation') {
              this.approvalShowPendingReturn = true;
              this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
            } else if(temp['status'] === 'Pending Passcard Return') {
              this.approvalShowComplete = true;
              this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
            } else {
              this.PARAM.forEach(k => k['form_input_attr'] = {disabled : true});
            }

            this.onReactivationDateChange();

            this.loadLicense();
          })
          .catch(error => {
            this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
          })
      } else {
        this.pageCanSubmit = true;
        let tempData = this.$refs['pageForm'].getFormDefaultData();
        tempData.lease = [{}];
        tempData['applicationCarpark'] = this.$route.query.carparkID;
        tempData['licenseID'] = this.$route.query.licenseID;
        tempData['_terminationDate'] = helper.formatDate(moment().startOf('day').add(1, 'month').subtract(1, 'day'));

        this.pageTitle = 'Reactivation Application';
        this.pageShowData = true;
        this.$refs['pageForm'].setForm(true, tempData);

        if(this.$refs['pageForm'].formData['applicationCarpark']) {
          this.loadLicense();
        }
      }
    },

    loadLicense() {
      this.hideFormFromKey('licenseID');
      let formData = this.$refs['pageForm'].formData;

      let url = helper.SERVER_URL;
      if(!this.$refs['pageForm'].formIsAdd) {
        url += '/api2/license/' + formData['licenseID'];
      } else {
        url += '/api2/carpark/' + formData['applicationCarpark'] + '/license/';
      }
      
      let feedbackItem = 'parking license data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();

          // TODO kw1 only show active license & lease
          if(this.$refs['pageForm'].formIsAdd) {
            response.data = response.data.filter(k => k.status === 'Active');
          }

          response.data.forEach(k => {
            k['_carpark'] = this.pageCarpark.find(j => j.id === k.carparkID);
            k['_customer'] = this.pageCustomer.find(j => j.id === k.customerID);
          });

          helper.inputSelectSetOption(this.PARAM_MAP['licenseID'], response.data);
          this.hideFormFromKey('sectionProductSubscription');

          if(!this.$refs['pageForm'].formIsAdd) {
            formData['applicationCarpark'] = response.data.find(k => helper.compareID(k.id, formData['licenseID']))['carparkID'];
            this.pageTitle += ' ' + helper.plFormPLTNum(formData['applicationNum'], formData['applicationCarpark']);
            this.$refs['pageForm'].$forceUpdate();
            this.loadApplicationData(formData['applicationData']);
            return;
          }

          if(formData['licenseID'] && response.data.find(k => helper.compareID(k.id, formData['licenseID']))) {
            this.loadLicenseLease();
          } else {
            this.$refs['pageFeedback'].setFeedbackMessage();
            formData['licenseID'] = null;
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadLicenseLease() {
      this.hideFormFromKey('sectionProductSubscription');

      this.pageSeason = null;
      this.pageParker = null;

      let feedbackItem = 'parking license lease data'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/license/' + this.$refs['pageForm'].formData['licenseID'] + '/lease/?current=1',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          if(this.$refs['pageForm'].formIsAdd) {
            response.data = response.data.filter(k => k.status === 'Active');
          }
          this.$refs['pageTableLease'].setLeaseData(this.$refs['pageForm'].formData['lease'] = response.data, true);
          this.loadPasscard();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    loadApplicationData(applicationData) {
      let feedbackItem = 'parking license reactivation application data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/applicationData/' + applicationData,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data;
          if(tempData) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.$refs['pageForm'].formData = Object.assign(tempData, this.$refs['pageForm'].formData);
            this.loadApplicationLease();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadApplicationLease() {
      let formData = this.$refs['pageForm'].formData;

      let feedbackItem = 'parking license reactivation application lease data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/lease/?applicationNum=' + formData['applicationNum'],
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let tempData = response.data;
          if(tempData) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            response.data.forEach(k => k['leaseSelected'] = true);
            this.$refs['pageTableLease'].setLeaseData(this.$refs['pageForm'].formData['lease'] = response.data, false);
            this.loadPasscard();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('Problem loading ' + feedbackItem);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    loadPasscard() {
      this.hideFormFromKey('licenseID');
      let formData = this.$refs['pageForm'].formData;

      let url = helper.SERVER_URL + '/api2/carpark/' + formData['applicationCarpark'] + '/passcard/';

      let feedbackItem = 'parking license passcard'
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          url,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage();
          this.pagePasscard = response.data;
          this.loadLeaseData();
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    loadLeaseData() {
      if(!this.pageSeason) {
        this.loadSeason();
        return;
      }

      if(!this.pageParker) {
        this.loadParker();
        return;
      }

      helper.inputSelectSetOption(this.PARAM_MAP['_lease'], [].concat('All Subscription', this.$refs['pageForm'].formData['lease']));

      this.calculateParkingFees();
    },
    loadSeason() {
      this.hideFormFromKey('sectionProductSubscription');

      let feedbackItem = 'product data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/carpark/' + this.$refs['pageForm'].formData['applicationCarpark'] + '/season/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageSeason = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadSeasonFees(seasonID) {
      this.hideFormFromKey('sectionProductSubscription');

      this.pageFees[seasonID] = null;

      let feedbackItem = 'product fees data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);

      this.$http
        .get(
          // helper.SERVER_URL + '/api2/season/' + seasonID + '/currentSeasonFees/',
          helper.SERVER_URL + '/api2/season/' + seasonID + '/seasonFees/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            // if(this.pageFees[seasonID] = response.data[0]) {
            if(this.pageFees[seasonID] = response.data.find(k => k.isActive)) {
              this.$refs['pageFeedback'].setFeedbackMessage();
              this.calculateParkingFees();
            } else {
              this.$refs['pageFeedback'].setFeedbackError('No active ' + feedbackItem + ' available.');
            }
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },
    loadParker() {
      this.hideFormFromKey('sectionProductSubscription');

      let customerID = helper.inputSelectFindOption(this.PARAM_MAP['licenseID'], this.$refs['pageForm'].formData['licenseID']).customerID;

      let feedbackItem = 'parker data';
      this.$refs['pageFeedback'].setFeedbackLoading('Loading ' + feedbackItem);
      this.$http
        .get(
          helper.SERVER_URL + '/api2/customer/' + customerID + '/subscriber/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          if(response.data && response.data.length > 0) {
            this.$refs['pageFeedback'].setFeedbackMessage();
            this.pageParker = response.data;
            this.loadLeaseData();
          } else {
            this.$refs['pageFeedback'].setFeedbackError('No ' + feedbackItem + ' available.');
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'loading', feedbackItem));
        })
    },

    calculateParkingFees() {
      let formData = this.$refs['pageForm'].formData;
      formData.lease = formData.lease || [];
      formData['applicationTotalPayable'] = 0.00;
      formData.lease.forEach(leaseData => {
        this.$refs['pageTableLease'].removeLeaseDataSeasonField(leaseData);
      });
      this.$refs['pageTableLease'].setLeaseTotal();

      if(this.checkSeasonFees()) {
        return;
      }

      let leaseTotal = {};
      this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => leaseTotal[k] = 0);

      let reactivationDateText = formData['_terminationDate'];
      let reactivationDate;
      if(reactivationDateText) {
        reactivationDate = helper.parseDateTime(reactivationDateText);
      }

      let tandemCalculated = [];
      formData.lease.forEach(leaseData => {
        let passcard = this.pagePasscard.find(k => helper.compareID(k.id, leaseData['passcardID']));
        leaseData['leasePasscard'] = (passcard || {}).sku;
        
        let applicationPaymentPlan = parseInt(leaseData['paymentPlan']);
        if(applicationPaymentPlan === undefined || applicationPaymentPlan === null) {
          return;
        }

        let applicationCommencementDateText = leaseData['commencementDate'];
        if(applicationCommencementDateText === undefined || applicationCommencementDateText === null) {
          return;
        }

        let applicationCommencementDate = helper.parseDateTime(applicationCommencementDateText);
        let daysInMonth = applicationCommencementDate.daysInMonth();
        let startDay = applicationCommencementDate.date();


        this.$refs['pageTableLease'].setLeaseDataParker(leaseData, this.pageParker.find(k => k.id === leaseData['parkerID']));
        let season = this.pageSeason.find(k => helper.compareID(k.id, leaseData['seasonID']));
        leaseData['leaseProductName'] = (season || {}).name;

        let zone = this.pageZone.find(k => helper.compareID(k.id, (season || {})['zoneID']));
        leaseData['leaseZone'] = (zone || {}).name;
        
        let product = this.pageFees[leaseData['seasonID']];
        if(!product) return;
        
        product.feesDeposit = parseFloat(product['deposit'] || 0);
        product.feesEstablishment = parseFloat(product['establishment'] || 0);
        product.fees1Month = parseFloat(product['monthly'] || 0);
        product.fees3Month = parseFloat(product['quarterly'] || 0) * 3;
        product.fees6Month = parseFloat(product['halfYearly'] || 0) * 6;
        product.fees12Month = parseFloat(product['annually'] || 0) * 12;
        
        leaseData['commencementDate'] = applicationCommencementDate.unix();
        leaseData['commencementDateText'] = helper.formatDate(leaseData['commencementDate']);
        leaseData['paymentPlan'] = applicationPaymentPlan;

        leaseData['leaseProductDeposit'] = product.feesDeposit;
        leaseData['leaseProductEstbFee'] = product.feesEstablishment;

        switch(applicationPaymentPlan) {
          case 1:
            leaseData['paymentPlanText'] = 'Monthly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees1Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
            }
            leaseData['leaseProductParkingFee'] = product.fees1Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / month';

            leaseData['leaseProRated'] = this.calculateProRated(reactivationDate, product.fees1Month);
            leaseData['leaseProRatedText'] = helper.formatMoney(leaseData['leaseProRated']);
            leaseData['leaseCreditAmount'] = leaseData['leaseProductParkingFee'] - leaseData['leaseProRated'];
            leaseData['leaseCreditAmountText'] = helper.formatMoney(leaseData['leaseCreditAmount']);
            leaseData['leaseRefundableFees'] = 0;
            leaseData['leaseRefundableFeesText'] = helper.formatMoney(leaseData['leaseRefundableFees']);
            break;
          case 2:
            leaseData['paymentPlanText'] = 'Quarterly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees3Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees3Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees3Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / quarter';
            
            leaseData['leaseProRated'] = this.calculateProRated(reactivationDate, product.fees3Month);
            leaseData['leaseProRatedText'] = helper.formatMoney(leaseData['leaseProRated']);
            leaseData['leaseCreditAmount'] = leaseData['leaseProductParkingFee'] - leaseData['leaseProRated'];
            leaseData['leaseCreditAmountText'] = helper.formatMoney(leaseData['leaseCreditAmount']);
            leaseData['leaseRefundableFees'] = 0;
            leaseData['leaseRefundableFeesText'] = helper.formatMoney(leaseData['leaseRefundableFees']);
            break;
          case 3:
            leaseData['paymentPlanText'] = 'Half-yearly';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees6Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees6Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees6Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / half-year';
            
            leaseData['leaseProRated'] = this.calculateProRated(reactivationDate, product.fees6Month);
            leaseData['leaseProRatedText'] = helper.formatMoney(leaseData['leaseProRated']);
            leaseData['leaseCreditAmount'] = leaseData['leaseProductParkingFee'] - leaseData['leaseProRated'];
            leaseData['leaseCreditAmountText'] = helper.formatMoney(leaseData['leaseCreditAmount']);
            leaseData['leaseRefundableFees'] = 0;
            leaseData['leaseRefundableFeesText'] = helper.formatMoney(leaseData['leaseRefundableFees']);
            break;
          case 4:
            leaseData['paymentPlanText'] = 'Annually';
            if(startDay == 1) {
              leaseData['leaseProductInitialParkingFee'] = product.fees12Month;
            } else {
              leaseData['leaseProductInitialParkingFee'] = (daysInMonth - startDay + 1) * (product.fees1Month / daysInMonth);
              leaseData['leaseProductInitialParkingFee'] += product.fees12Month;
            }
            leaseData['leaseProductParkingFee'] = product.fees12Month;
            leaseData['leaseProductParkingFeeText'] = helper.formatMoney(leaseData['leaseProductParkingFee']) + ' / annual';
            
            leaseData['leaseProRated'] = this.calculateProRated(reactivationDate, product.fees12Month);
            leaseData['leaseProRatedText'] = helper.formatMoney(leaseData['leaseProRated']);
            leaseData['leaseCreditAmount'] = leaseData['leaseProductParkingFee'] - leaseData['leaseProRated'];
            leaseData['leaseCreditAmountText'] = helper.formatMoney(leaseData['leaseCreditAmount']);
            leaseData['leaseRefundableFees'] = 0;
            leaseData['leaseRefundableFeesText'] = helper.formatMoney(leaseData['leaseRefundableFees']);
            break;
        }

        leaseData['leaseProductInitialPayment'] = product.feesDeposit + product.feesEstablishment + leaseData['leaseProductInitialParkingFee'];

        this.$refs['pageTableLease'].PRODUCT_PARAMS.forEach(k => {
          if(!leaseData['pairID'] || !tandemCalculated.includes(leaseData['pairID'])) {
            leaseTotal[k] += leaseData[k];
          }
          leaseData[k + 'Text'] = leaseData[k + 'Text'] || helper.formatMoney(leaseData[k]);
        });
        tandemCalculated.push(leaseData['pairID']);
      });

      this.$refs['pageTableLease'].setLeaseTotal(leaseTotal);
      formData['applicationTotalPayable'] = leaseTotal['leaseProductInitialPaymentText'];

      this.hideFormFromKey(null);
    },
    calculateProRated(reactivationDate, parkingFees) {
      if(!reactivationDate) {
        return 0;
      }

      let reactivationDay = reactivationDate.date();
      let reactivationMonthDay = moment(reactivationDate).endOf('month').date();
      return parkingFees / reactivationMonthDay * reactivationDay;
    },
    checkSeasonFees() {
      let formData = this.$refs['pageForm'].formData;
      for(let leaseData of formData.lease) {
        if(leaseData['seasonID'] && this.pageFees[leaseData['seasonID']] === undefined) {
          // load season fees
          this.loadSeasonFees(leaseData['seasonID']);
          return true;
        }
      };
    },

    onCancelButtonClick() {
      helper.redirect({ path: helper.WEB_URL + '/plReactivation', query: { carparkID: this.$refs['pageForm'].formData.applicationCarpark }});
    },
    onSaveButtonClick() {
      if(!this.$refs['pageForm'].validateForm() && !this.validateApplicationData()) {
        this.addApplicationData({});
      }
    },
    validateApplicationData() {
      let formData = this.$refs['pageForm'].formData;
      let hasSelected = false;
      if(!formData.lease.find(k => k.leaseSelected)) {
        this.$refs['pageTableLease'].$refs['leaseFeedback'].setFeedbackError('Please select at least one subscription to proceed');
        $(document).scrollTop($('#jt-form-div-sectionProductSubscription')[0].offsetTop);
        return true;
      }

      if(!formData['applicationTnC']) {
        this.$refs['pageFeedback'].setFeedbackError('Please agree to the terms and conditions to proceed');
        return true;
      }

      // TODO kw1 validate refund method field
    },
    
    addApplicationData(data) {
      let formData = this.$refs['pageForm'].formData;
      formData['applicationStatus'] = 1;

      let actualData = $.extend(true, {}, formData);
      actualData.lease = [];
      formData.lease.forEach(leaseData => {
        if(leaseData.leaseSelected) {
          actualData.lease.push(leaseData);
        }
      });
      // TODO kw1 hardcode all reactivation has refund
      actualData.refundAmount = 10;

      let feedbackItem = 'parking license reactivation appplication data';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .put(
          helper.SERVER_URL + '/api2/applicationData/',
          querystring.stringify({application: JSON.stringify(actualData)}),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFeedback'].setFeedbackMessage('Successfully added ' + feedbackItem);
          data['applicationDataID'] = response.data;
          if(this.$refs['pageForm'].formIsAdd) {
            this.addApplication(data);
          } else {
            this.editApplication(data);
          }
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    addApplication(data) {
      let formData = this.$refs['pageForm'].formData;
      let tempData = {};
      tempData['applicationData'] = data['applicationDataID'];
      tempData['licenseID'] = formData['licenseID'];
      tempData['reactivationDate'] = helper.parseDateTime(formData['_terminationDate']).unix();
      tempData['leases'] = [];
      formData.lease.forEach(leaseData => {
        if(leaseData.leaseSelected) {
          tempData['leases'].push(leaseData);
          return;
        }
      });
      tempData['leases'] = JSON.stringify(tempData['leases']);

      let feedbackItem = 'parking license reactivation appplication';
      this.$refs['pageFeedback'].setFeedbackLoading('Adding ' + feedbackItem);
      this.$http
        .post(
          helper.SERVER_URL + '/api2/carpark/' + formData['applicationCarpark'] + '/licenseTerminate/',
          querystring.stringify(tempData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageForm'].formData.id = response.data[0].id;
          this.onApproveButtonClick();
          // this.upsertDataComplete('Successfully added ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    editApplication(data) {
      let formData = this.$refs['pageForm'].formData;
      let tempData = {};
      tempData['applicationData'] = data['applicationDataID'];
      tempData['reactivationDate'] = helper.parseDateTime(formData['_terminationDate']).unix();

      let feedbackItem = 'parking license reactivation appplication';
      this.$refs['pageFeedback'].setFeedbackLoading('Updating ' + feedbackItem);
      this.$http
        .put(
          helper.SERVER_URL + '/api2/carpark/' + formData['applicationCarpark'] + '/licenseTerminate/' + formData.id,
          querystring.stringify(tempData),
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully updated ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'updating', feedbackItem));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      helper.redirect({ path: helper.WEB_URL + '/plReactivation', query: { carparkID: this.$refs['pageForm'].formData.applicationCarpark }});
    },

    onFormChange(formData, formParameter, input) {
    },
    onFormInput(formData, formParameter, input) {
      if(formParameter.key === 'applicationCarpark') {
        this.$refs['pageForm'].formData['licenseID'] = null;
        this.loadLicense();
      } else if(formParameter.key === 'licenseID') {
        this.loadLicenseLease();
      } else if(formParameter.key === '_lease') {
        formData['lease'].forEach(k => {
          if(formData['_lease'].includes('All Subscription')) {
            k.leaseSelected = true;
          } else {
            k.leaseSelected = formData['_lease'].includes('' + k.id);
          }
        });
        this.$refs['pageTableLease'].$forceUpdate();
      } else if(formParameter.key === '_terminationDate') {
        this.onReactivationDateChange();
        this.calculateParkingFees();
      } else if(formParameter.key === 'reactivationRefundMethod') {
        this.hideFormFromKey(null);
      } else if(formParameter.key === 'applicationStaff') {
        let staff = helper.inputSelectFindOption(this.PARAM_MAP['applicationStaff'], this.$refs['pageForm'].formData['applicationStaff']) || {}
        this.$refs['pageForm'].formData['applicationStaffNo'] = staff['personnelCode'];
      }
    },
    onReactivationDateChange() {
      let formData = this.$refs['pageForm'].formData;
      let reactivationDate = helper.parseDateTime(formData['_terminationDate']);
      if(this.$refs['pageForm'].formIsAdd) {
        if(reactivationDate < moment().startOf('day').add(1, 'month').subtract(1, 'day')) {
          this.$refs['reactivationDateFeedback'].setFeedbackError('Insufficient Notice Period, Deposit will be forfeited');
        } else {
          this.$refs['reactivationDateFeedback'].setFeedbackError(null);
        }
      } else {
        if(reactivationDate < helper.parseDateTime(formData['createDate']).startOf('day').add(1, 'month').subtract(1, 'day')) {
          this.$refs['reactivationDateFeedback'].setFeedbackError('Insufficient Notice Period, Deposit will be forfeited');
        } else {
          this.$refs['reactivationDateFeedback'].setFeedbackError(null);
        }
      }
    },

    onApproveButtonClick() {
      let feedbackItem = 'parking license reactivation application';
      this.$refs['pageFeedback'].setFeedbackLoading('Approving ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licenseTerminate/' + this.$refs['pageForm'].formData.id + '/approve',
          null,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully approve ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'approving', feedbackItem));
        })
    },
    onPendingReturnButtonClick() {
      let feedbackItem = 'parking license reactivation application status to pending passcard return';
      this.$refs['pageFeedback'].setFeedbackLoading('Changing ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licenseTerminate/' + this.$refs['pageForm'].formData.id + '/pendingReturn',
          null,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully changed ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'changing', feedbackItem));
        })
    },
    onCompleteButtonClick() {
      let feedbackItem = 'parking license reactivation application status to completed';
      this.$refs['pageFeedback'].setFeedbackLoading('Changing ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licenseTerminate/' + this.$refs['pageForm'].formData.id + '/completed',
          null,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully changed ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'changing', feedbackItem));
        })
    },
    onExpiredButtonClick() {
      let feedbackItem = 'parking license reactivation application status to expired';
      this.$refs['pageFeedback'].setFeedbackLoading('Changing ' + feedbackItem);
      this.$http
        .post(
          helper.API_URL + '/api2/licenseTerminate/' + this.$refs['pageForm'].formData.id + '/expired',
          null,
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully changed ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageFeedback'].setFeedbackError(helper.parseAxiosErrorMessage(this, error, 'changing', feedbackItem));
        })
    },

    hasAddOrEditPermission() {
      if(this.pageIsAdd) {
        return helper.hasAddPermission(this.permission);
      } else {
        return helper.hasEditPermission(this.permission);
      }
    },
    hasDeletePermission() {
      return helper.hasDeletePermission(this.permission);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLReactivationForm.vue